
export const VIRTUAL_CARD = "Virtual Card";
export const VCN = "VCN";
export const VC= "VC";
export const ALL_STRING="all"
export const GREEN_CLR_CODE = "#0C5D2E";
export const ORANGE_CLR_CODE = "#D65513";
export const MAILTO_SUBJECT = "Inquiry for JPMorgan Supplier Enablement Team";

//PaymentTerm Page
export const INTEREST_RATE_VALUE = 9;
export const NON_ENROLLED_TERMS = "Non-Enrolled Terms";
export const CURRENT_TERMS = "Current Payment Terms";
export const MULTIPLIED_BY = "Multiplied by";
export const DIVIDED_BY = "Divided by 365 days";
export const RESET_ALL = "Reset All Values";
export const DSO_CALCULATOR_STRING1 =
  "Total is multiplied by your Days Sales Outstanding (DSO)";
export const DSO_CALCULATOR_STRING2 =
  "Equals your estimated working capital cost";
export const DSO_CALCULATOR_STRING3 =
  "Your estimated working capital breakdown with";
export const PAYMENTTERM = "Payment Terms";
export const FAQS = "FAQs";
export const SINGLE_BUYER_DESCRIPTION =
  " Working capital is estimated by multiplying your selected projected Annual Sales and Interest Rate then dividing that amount by 365 days. That total is then multiplied by the Days Sales Outstanding(DSO) selected.";
export const DSO_TOOLTIP =
  "<div class='font-bold'>Days sales outstanding (DSO)</div> measures the average number of days it takes for a company to collect cash from credit purchases. DSO is calculated as the average accounts receivable (A/R) outstanding divided by revenue, multiplied by the number of days in the period of time (usually 365 days).";
export const DSO_TOOLTIP_LABEL =
  "Days sales outstanding (DSO) measures the average number of days it takes for a company to collect cash from credit purchases. DSO is calculated as the average accounts receivable (A/R) outstanding divided by revenue, multiplied by the number of days in the period of time (usually 365 days).";

export const CALCULATION_DISCLAIMER =
  "All calculations are estimates and J.P. Morgan disclaims any liability arising from Supplier’s reliance on the estimated savings shown above.";
export const MULTIPLE_BUYER_HEADING =
  "Help improve your Working Capital with exclusive Payment Terms";
export const INTEREST_RATE = "Weighted Average Cost of Capital (WACC)";
export const ESTIMATED_WORKING =
  "Calculate your estimated Working Capital by customer";
export const MULTIPLE_BUYER_DISCLAIM =
  "Only buyers where current payment terms have been advised are shown.";
export const MULTIPLE_BUYER_TOTAL_CAL_HEADING =
  "Total Estimated Working Capital*";
export const MULTIPLE_BUYER_TOTAL_CAL_DEFAULT_WC =
  "Your default cost of working capital";
export const MULTIPLE_BUYER_TOTAL_CAL_VC_LABEL = "Cost with Virtual Card";
export const MULTIPLE_BUYER_TOTAL_CAL_VCN_LABEL =
  "Virtual Connect Network exclusive terms savings";
export const MULTIPLE_BUYER_TOTAL_CAL_WITHOUT_VC_LABEL =
  "Cost without Virtual Card";
export const MULTIPLE_BUYER_TOTAL_CAL_WITHOUT_VCN_LABEL =
  "Cost without Virtual Connect Network";

export const MULTIPLE_BUYER_COST_INFO =
  " *Based on Enrollment Terms and reported sales from your Customer";
export const DOLLAR_SYMOBOL = "$";

// How It Works Page
export const BUYERLIST_HEADING = "The following";
export const BUYERLIST_HEADING1 = "Customers of";
export const BUYERLIST_HEADING2 = "are offering to pay by";
export const HOW_IT_WORKS = "How It Works";
export const VIEWPAYMENTTERMS = "View Payment Terms";

// Footer
export const FOOTER_TEXT = " JPMorgan Chase & Co. All rights reserved.";
export const TERMS_CONDITIONS = "Terms & Conditions";
export const PRIVACY_STRING = "Privacy Policy & Disclosures";
export const FOOTER_TNC_URL =
  "https://www.jpmorganchase.com/legal/terms-and-conditions";
export const FOOTER_PRIVACY_URL = "https://www.jpmorgan.com/privacy";
export const CONTACTUS = "Contact Us";

export const ssnRegex = /^(?!000|666|9\d{2})\d{3}(?!00)\d{2}(?!0000)\d{4}$/;
export const itinRegex =
  /^9\d{2}(7[0-9]|8[0-8]|90|91|92|94|95|96|97|98|99)\d{4}$/;
export const atinRegex = /^90093\d{4}$/;

export const invalidSSNs = ["111111111", "333333333", "666666666", "123456789"];

export const ssnRanges = [
  { min: "001010001", max: "665999999" },
  { min: "667010001", max: "899999999" },
  { min: "750010001", max: "763999999" },
  { min: "764010001", max: "899999999" },
];

export const itinRanges = [
  { min: "900700000", max: "999889999" },
  { min: "999909999", max: "999929999" },
  { min: "999940000", max: "999999999" },
];
export const atinRange = { min: "900930000", max: "999939999" };

export const US_STATES = [
  { code: "AL", name: "Alabama" },
  { code: "AK", name: "Alaska" },
  { code: "AS", name: "American Samoa" },
  { code: "AZ", name: "Arizona" },
  { code: "AR", name: "Arkansas" },
  { code: "CA", name: "California" },
  { code: "CO", name: "Colorado" },
  { code: "CT", name: "Connecticut" },
  { code: "DE", name: "Delaware" },
  { code: "DC", name: "District of Columbia" },
  { code: "FL", name: "Florida" },
  { code: "GA", name: "Georgia" },
  { code: "GU", name: "Guam" },
  { code: "HI", name: "Hawaii" },
  { code: "ID", name: "Idaho" },
  { code: "IL", name: "Illinois" },
  { code: "IN", name: "Indiana" },
  { code: "IA", name: "Iowa" },
  { code: "KS", name: "Kansas" },
  { code: "KY", name: "Kentucky" },
  { code: "LA", name: "Louisiana" },
  { code: "ME", name: "Maine" },
  { code: "MD", name: "Maryland" },
  { code: "MA", name: "Massachusetts" },
  { code: "MI", name: "Michigan" },
  { code: "MN", name: "Minnesota" },
  { code: "MS", name: "Mississippi" },
  { code: "MO", name: "Missouri" },
  { code: "MT", name: "Montana" },
  { code: "NE", name: "Nebraska" },
  { code: "NV", name: "Nevada" },
  { code: "NH", name: "New Hampshire" },
  { code: "NJ", name: "New Jersey" },
  { code: "NM", name: "New Mexico" },
  { code: "NY", name: "New York" },
  { code: "NC", name: "North Carolina" },
  { code: "ND", name: "North Dakota" },
  { code: "MP", name: "Northern Mariana Islands" },
  { code: "OH", name: "Ohio" },
  { code: "OK", name: "Oklahoma" },
  { code: "OR", name: "Oregon" },
  { code: "PA", name: "Pennsylvania" },
  { code: "PR", name: "Puerto Rico" },
  { code: "RI", name: "Rhode Island" },
  { code: "SC", name: "South Carolina" },
  { code: "SD", name: "South Dakota" },
  { code: "TN", name: "Tennessee" },
  { code: "TX", name: "Texas" },
  { code: "UM", name: "United States Minor Outlying Islands" },
  { code: "UT", name: "Utah	UT" },
  { code: "VT", name: "Vermont" },
  { code: "VI", name: "Virgin Islands" },
  { code: "VA", name: "Virginia" },
  { code: "WA", name: "Washington" },
  { code: "WV", name: "West Virginia" },
  { code: "WI", name: "Wisconsin" },
  { code: "WY", name: "Wyoming" },
];

export const validationMessages = {
  name: [
    "Company name is required",
    "Please provide a valid company name : must be under 100 character",
  ],
  supplier_address: [
    "Remittance Address is required",
    "Please provide a valid Remittance Address : must be under 100 character",
  ],
  supplier_city: [
    "City is required",
    "Please provide a valid city  : must be under 50 character",
  ],
  cityA: [
    "City is required",
    "Please provide a valid city  : must be under 50 character",
  ],
  supplier_state: ["State is required"],
  stateA: ["State is required"],
  supplier_zipcode: ["Zipcode is required", "Please provide a valid Zipcode"],
  zipCodeA: ["Zipcode is required", "Please provide a valid Zipcode"],
  payeeFirstName: ["Payee First Name is required"],
  payeeLastName: ["Payee Last Name is required"],
  taxPayerId: [
    "Taxpayer Id is required",
    "Please enter a valid Taxpayer Id or SSN : should be 9 digits",
  ],
  mailingAddress: ["Mailing Address is required"],
  financialInstituteName: [
    "Financial Institution Name is required",
    "Financial Institution Name should not exceed 100 characters",
  ],
  accountCurrency: [""],
  country: [""],
  financialInstituteAddress: [
    "Financial Institution Address is required",
    "Financial Institution Address should not exceed 256 characters",
  ],
  accountName: ["Account Name is required"],
  routingNumber: [
    "Routing Number is required",
    "Please enter a valid Routing / ABA number",
  ],
  accountNumber: [
    "Account Number is required",
    "Please enter a valid Account number",
  ],
  typeOfAccount: [
    "Account type is required",
    "Please enter a valid Account type",
  ],
  confirmAccountNumber: [
    "Confirm Account Number is required",
    "The numbers do not match. Please try again.",
  ],
  emailAddress: [
    "Email Address is required",
    "Email Address is in invalid format",
  ],
};
export const HUNDRED_VALUE_STRING = "100";
export const ZERO_VALUE_STRING = "0";
export const MINUTE_TIMER_TIMEOUT =60 * 1000
export const TWENTY_FIVE_MINUTES_TIMER= 25 * 60 * 1000; //25 minutes in milliseconds
export const ACH_SESSION_PAGE_H1 = "Session Timeout";
export const ACH_SESSION_PAGE_H2 =
  " For your security, your ACH enrollment request has been canceled due to 25 minutes of inactivity.";
export const ACH_SESSION_PAGE_H3 =
  "To continue with the process, please follow these steps:";
export const ACH_SESSION_PAGE_STEP1 =
  "1. Locate your invitation email: Find the email we sent you containing the unique enrollment link.";
export const ACH_SESSION_PAGE_STEP2 =
  "2. Click the enrollment link: Open the email and click on the link provided. This will start a new, secure session.";
export const ACH_ERROR_PAGE_H1 = "Enrollment request was unsuccessful.";
export const ACH_ERROR_PAGE_H2 =
  "Unfortunately, your ACH enrollment request cannot be completed at this time.";
export const ACH_ERROR_PAGE_TXT =
  "Please contact us and we will assist you with the enrollment process. Thank you for your cooperation.";
export const ACH_THANKS_H1 =
  "Your enrollment request was successfully received!";
export const ACH_THANKS_PARTIAL_SUCCESS_H1 =
  "Your enrollment request was partially successful.";
export const ACH_THANKS_TEXT_DESCRIPTION =
  "Once your buyer(s) have confirmed your request, your ACH enrollment will be complete. Please contact your buyers if you have any question with the enrollment status.";
export const ACH_THANKS_CONTACT_DESCRIPTION =
  "To update your enrollment information or have any question for Virtual Card or ACH Payments, please contact us.";
export const isValidEmail = (value: string) =>
  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?<!\.com\.com)$/.test(value);
export const SUCCESS_STR = "SUCCESS";
export const CONTINUE_TO_ACH_ENROLLMENT_BTN = "Continue to ACH Enrollment";


//Enroll VCN Page
export const ENROLL_VCN_HEADING = "Enroll in Virtual Connect Network";
export const CALL = "Call";
export const VCN_CONTACT = "1 (877) 551 0770";
export const ENROLLMENT_SERVICE = "Concierge enrollment service";
export const AVAILABLE_INFO =
  "Available from Monday through Friday, 8 am - 6 pm ET, excluding US Public Holidays.";
export const EMAIL_LABEL = "Email";
export const VCN_ENROLLMENT_DESCRIPTION =
  "Enroll in your own time or schedule an appointment.";
export const SEND_EMAIL_BTN = "Send Email";
export const LEARN_ABT_VCN = "Learn More about VCN";
export const MAIL_BODY =
  "* First Name: \n\n* Last Name: \n\n* Company Name: \n\n* Title: \n\n* Preferred Way of Contact (Email/Mobile/Both): \n- Please provide best number to contact if preferred method includes Phone: \n\n* Inquiry Details: \n\n\n\nThank you";
export const VC_EMAIL_ID = "supplier.enrollment@jpmchase.com";
export const VCN_EMAIL_ID = "Virtual.Connect.Network@jpmorgan.com";
export const ACH_EMAIL_ID = "supplier.enrollment@jpmchase.com";
